const RegisterContractView = () => import(/* webpackChunkName: "contract" */'../views/contract/RegisterContractView')

const KPI_FEATURE = 'kpi'

export default [
  {
    path: '/:tenant/overview',
    name: 'contract-overview',
    component: () => import(/* webpackChunkName: "contract" */ '../views/contract/ContractOverview'),
    meta: {
      title: 'avtala.contract.overview.label',
      menu: true,
      icon: 'mdi-helicopter',
      tenant: true,
      permission: 'contract:read'
    }
  },
  {
    path: '/:tenant/contract',
    name: 'list-contract',
    components: {
      default: () => import(/* webpackChunkName: "contract" */'../views/contract/ContractListView'),
      sidebar: () => import(/* webpackChunkName: "contract" */'../components/ContractListSidebar'),
    },
    meta: {
      title: 'avtala.contract.list.label',
      icon: '$search',
      menu: true,
      tenant: true,
      permission: 'contract:read'
    }
  },
  {
    path: '/:tenant/contract/register',
    name: 'register-contract',
    component: RegisterContractView,
    props: route => ({ contact: route.query?.contact }),
    meta: {
      title: 'avtala.contract.create.label',
      icon: 'add_circle_outline',
      tenant: true,
      menu: true,
      permission: 'contract:create'
    }
  },
  {
    path: '/:tenant/contract/register/:category',
    name: 'register-contract-category',
    component: RegisterContractView,
    props: route => ({ category: route.params.category }),
    meta: {
      title: 'avtala.contract.create.label',
      icon: 'add_circle_outline',
      tenant: true,
      permission: 'contract:create'
    }
  },
  {
    path: '/:tenant/timeline',
    name: 'timeline',
    component: () => import(/* webpackChunkName: "contract" */'../views/contract/ContractTimeline'),
    meta: {
      title: 'avtala.timeline.label',
      menu: true,
      icon: 'mdi-chart-timeline',
      tenant: true,
      permission: 'contract:read'
    }
  },
  {
    path: '/:tenant/calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "calendar" */ '../views/home/CalendarView'),
    meta: {
      title: 'avtala.calendar.label',
      icon: 'schedule',
      menu: true,
      tenant: true,
      permission: 'activity:read'
    }
  },
  {
    path: '/:tenant/contract/show/:id',
    name: 'avtala-contract-show',
    components: {
      default: () => import(/* webpackChunkName: "contract" */'../views/contract/ContractView')
    },
    meta: {
      title: 'avtala.contract.show.label',
      icon: 'mdi-file-document-edit-outline',
      tenant: true,
      permission: 'contract:read'
    }
  },
  {
    path: '/:tenant/contract/follow-up/:id',
    name: 'contract-followup',
    component: () => import(/* webpackChunkName: "analysis" */ '../views/followup/RequirementsView'),
    meta: {
      title: 'avtala.contract.followup.label',
      icon: 'done_all',
      tenant: true,
      feature: KPI_FEATURE,
      permission: 'contract:read'
    }
  },
  {
    path: '/:tenant/contract/email/:id',
    name: 'contract-email',
    props: true,
    component: () => import(/* webpackChunkName: "inspection" */ '../views/contract/SendEmailView'),
    meta: {
      tenant: true
    }
  },

  // ---------- ADMIN ----------
  {
    path: '/:tenant/admin/contract-view',
    name: 'contract-view',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractViewListView'),
    meta: {
      title: 'Avtalsvyer',
      icon: 'mdi-folder-text',
      tenant: true,
      admin: true,
      contract: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/admin/contract-view/:id',
    props: true,
    name: 'contract-view-edit',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractViewAdminView'),
    meta: {
      title: 'Avtalsvy',
      icon: 'mdi-folder-text',
      tenant: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/admin/contract-category',
    name: 'contract-category',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractCategoryListView'),
    meta: {
      title: 'Avtalskategorier',
      icon: 'mdi-file-document-edit',
      tenant: true,
      admin: true,
      contract: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/admin/contract-category/:id?',
    props: route => ({ ...route.params, view: route.query.view }),
    name: 'contract-category-edit',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractCategoryAdminView'),
    meta: {
      title: 'Avtalskategori',
      icon: 'mdi-file-document-edit',
      tenant: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/admin/contract-type',
    name: 'contract-type',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractTypeAdminView'),
    meta: {
      title: 'Avtalstyper',
      icon: 'mdi-file-document',
      tenant: true,
      admin: true,
      contract: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/admin/contract-status',
    name: 'contract-status',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractStatusAdminView'),
    meta: {
      title: 'Avtalsstatusar',
      icon: 'mdi-state-machine',
      tenant: true,
      admin: true,
      contract: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/admin/contract-role',
    name: 'contract-role',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractRoleListView'),
    meta: {
      title: 'Avtalsroller',
      icon: 'mdi-file-account',
      tenant: true,
      admin: true,
      contract: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/admin/contract-role/:id',
    props: true,
    name: 'contract-role-edit',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/ContractRoleAdminView'),
    meta: {
      title: 'Avtalsroll',
      icon: 'mdi-file-account',
      tenant: true,
      permission: 'contract:admin'
    }
  },
  {
    path: '/:tenant/feedback/:id',
    props: true,
    name: 'feedback-form',
    component: () => import(/* webpackChunkName: "admin" */ '../views/followup/FeedbackView'),
    meta: {
      title: 'Uppföljning',
      icon: 'mdi-file-account',
      tenant: true,
      permission: 'contract:read'
    }
  },
  {
    path: '/:tenant/document/sign/:id',
    props: true,
    name: 'content-sign',
    component: () => import(/* webpackChunkName: "sign" */ '../views/sign/SignView'),
    meta: {
      title: 'Elektronisk signering',
      icon: '$sign',
      tenant: true,
      permission: 'contract:admin'
    }
  },
]
